import ProductLabel from './productLabel.vue'
import Product from './product.vue'
import SkuLabel from './skuLabel.vue'
import Sku from './sku.vue'
import Coupon from './coupon.vue'
import Tproduct from './tproduct.vue'
import Card from './card.vue'
import CardInfo from './cardInfo.vue'
export default {
	ProductLabel,
	Product,
	SkuLabel,
	Sku,
	Coupon,
	Tproduct,
	Card,
	CardInfo
}



// WEBPACK FOOTER //
// ./src/views/product/index.js